import React, { Component } from "react";
import ReactApexChart from "react-apexcharts";

export default class SDWanHealth extends Component {
  constructor(props) {
    super(props);
    const removeZeros = (data) =>
      data.map((value) => (value === 0 ? null : value));
    this.state = {
      series: [
        {
          name: "Down",
          data: removeZeros([0, 1, 10, 0, 0, 0, 2, 0]),
        },
        {
          name: "Up",
          data: removeZeros([16, 5, 14, 18, 44, 0, 6, 6]),
        },
      ],
      options: {
        chart: {
          type: "bar",
          height: 350,
          stacked: false,
          toolbar: {
            show: true,
          },
          zoom: {
            enabled: true,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "80%",
            borderRadius: 1,
            dataLabels: {
              position: "top",
            },
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ["#605E5C"],
            fontSize: "12px",
            fontWeight: 600,
          },
          offsetY: -20,
        },
        xaxis: {
          categories: [
            "BGP Adjencencies",
            "Config Sync Status",
            "IKE Status",
            "Interfaces",
            "Paths",
            "Physical Ports",
            "Reachability Status",
            "Service Status",
          ],

          labels: {
            style: {
              fontSize: "10px",
              fontWeight: 700,
              margin: {
                top: 0, // Adjust these margins to control spacing around labels
                right: 0,
                bottom: 0,
                left: 0,
              },
            },
            rotate: -30,
          },

          title: {
            style: {
              fontSize: "14px",
            },
          },
        },
        yaxis: {
          labels: {
            style: {
              fontSize: "10px",
              fontWeight: "bold",
            },
          },
          title: {
            text: "Incidents", // Title for the X-axis
            style: {
              fontSize: "13px",
              fontWeight: "8px",
            },
          },
          // Use logarithmic scale
          logarithmic: true,
          min: 1, // Start from 1 since log scale does not support 0
          tickAmount: 5, // Control the number of ticks on the Y-axis
        },
        fill: {
          opacity: 1,
        },
        colors: [
          "#DA4949", // Down
          "#94CD3A", // Up
        ],

        legend: {
          position: "bottom",
          horizontalAlign: "center",
          fontWeight: "10px",
          //   offsetX: 40,
        },
      },
    };
  }

  render() {
    return (
      <div>
        {this.props.message === "Data found" ? (
          <ReactApexChart
            options={this.state.options}
            series={this.state.series}
            type="bar"
            height={300}
          />
        ) : (
          <div
            style={{
              fontSize: "25px",
              fontWeight: "bold",
              textAlign: "center",
              color: "#605E5C",
            }}
          >
            {this.props.message}
          </div>
        )}
      </div>
    );
  }
}
